import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import PurchaseForm from './PurchaseForm';

export class PurchaseCreateForm extends CreateView {
    protected getFormComponent() {
        return PurchaseForm;
    }
}

export default PurchaseCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(PurchaseCreateForm));
